var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDollarcircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.004 10.9975C7.004 11.965 7.7465 12.745 8.669 12.745H10.5515C11.354 12.745 12.0065 12.0625 12.0065 11.2225C12.0065 10.3075 11.609 9.985 11.0165 9.775L7.994 8.725C7.4015 8.515 7.004 8.1925 7.004 7.2775C7.004 6.4375 7.6565 5.755 8.459 5.755H10.3415C11.264 5.755 12.0065 6.535 12.0065 7.5025M9.5 4.75V13.75",
    stroke: "#FF5400",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 16.75C13.6423 16.75 17 13.3922 17 9.25C17 5.10775 13.6423 1.75 9.5 1.75C5.35775 1.75 2 5.10775 2 9.25C2 13.3922 5.35775 16.75 9.5 16.75Z",
    stroke: "#FF5400",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarcircle);
export default __webpack_public_path__ + "static/media/dollarcircle.dc60057b5a11041824ffaab671c462f7.svg";
export { ForwardRef as ReactComponent };